import React from 'react';
import { connect } from 'react-redux';
import MyGridRedux from '../../components/MyGridRedux/MyGridRedux';
import { AppState } from '../../store/state';
import { AppDispatch } from '../../store/store';
import { selectInfo, selectKeywordState, selectTrackRoles } from '../../store/selectors';
import { Role } from '../../store/conference/types';
import { ChairInfo, Info, TableFriendlyName } from '../../store/info/types';
import Loading from '../../components/Loading/Loading';
import { formatKeywordColumn } from '../../helpers/table';
import { useTranslation } from 'react-i18next';
import useFetchTableData from '../../store/table/useFetchTableData';
import { stringifyOrganization } from '../../helpers/users';
import { doesHandleReviewers } from '../../helpers/role';

interface Props {
  info: Info;
  loading: boolean;
  roleById: { [key: string]: Role };
  keywordById: { [key: number]: Keyword };
}

const ReviewersBidsPage: React.FC<Props> = ({ info, loading, roleById, keywordById }) => {
  const { t, i18n } = useTranslation();
  const friendlyName: TableFriendlyName = 'reviewers_bids';
  const [fetchData, fetchCustomColumnsData] = useFetchTableData(friendlyName);

  if (loading) {
    return <Loading />;
  }

  const chairInfo = info as ChairInfo;

  /* Build input data */
  const inputData: unknown[] = [];
  Object.values(chairInfo.users.byId).forEach((register) => {
    register.role_ids.forEach((roleId, index) => {
      const role = roleById[roleId];
      const personRoleId = register.person_role_ids[index];
      if (role.type == 'reviewer' && !doesHandleReviewers(role)) {
        const newRegister = {
          ...register,
          id: personRoleId,
          role_id: roleId,
          person_role_id: personRoleId,
        };

        // Add Role description
        // @ts-ignore
        newRegister.role = roleById[roleId].description;

        formatKeywordColumn(newRegister, keywordById);

        newRegister.organization = stringifyOrganization(newRegister);

        inputData.push(newRegister);
      }
    });
  });

  return (
    <div className="flex flex-col h-full">
      <div className="h-full">
        {loading ? (
          <Loading />
        ) : (
          <MyGridRedux
            friendlyName={friendlyName}
            inputData={inputData as Record<string, unknown>[]}
            getInfoAction={fetchData}
            getCustomColumnsData={fetchCustomColumnsData}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  info: state.info.info,
  loading: selectInfo(state).loading,
  roleById: selectTrackRoles(state),
  keywordById: selectKeywordState(state).keywordById,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewersBidsPage);
